import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/internal-compatibility';
import { map } from 'rxjs/operators';
import { BetaFeature, PerfilService } from '../ajs-perfil.service';
import { CacheableGet } from './cacheable-get';
import { FIVE_MINUTES_IN_MILLIS, PROFILE_CACHE_TIME } from './consts';

@Injectable({
  providedIn: 'root'
})
export class ProfileBetaFeatureService {

  private getRequest: CacheableGet<BetaFeature[]>;

  public get shouldUpdate() {
    return this.getRequest.shouldUpdate;
  }

  constructor(
    private perfilService: PerfilService,
    @Optional() @Inject(PROFILE_CACHE_TIME) cacheTime: number,
  ) {
    if (!cacheTime) {
      cacheTime = FIVE_MINUTES_IN_MILLIS;
    }

    this.getRequest = new CacheableGet<BetaFeature[]>(
      cacheTime,
      () => fromPromise(this.perfilService.getBetaFeatures()).pipe(map(response => response.funcionalidades)),
    );
  }

  /**
   * Obtém os dados para o cliente atual
   */
  public getBetaFeatures(): Observable<BetaFeature[]> {
    return this.getRequest.get();
  }

  public hasFeature(featureName: string): Observable<boolean> {
    return this.getBetaFeatures().pipe(
      map(features => {
        const feature = features.find(f => f.codigo === featureName);

        return feature && feature.possuiAcesso;
      }),
    );
  }
}
